import {updateEndFilter} from "../../event.js";
import * as constants from "../../widgetConstants.js";
import {getFilterText} from "../../widgetConstants.js";

function addFilterEvent(props) {

    const {
        $w, //타겟 위젯
        filterGb, //필터구분
    } = props;
    const $this = this;

    /*필터버튼*/
    $($w.find('.button-filter')).off('click').on('click', (e) => {
        toggleFilterPopup()
    })

    /*필터팝업*/
    $($w.find('.js-filter-input')).off('click').on('click', (e) => {
        const $eTarget = $(e.target);
        if (!$eTarget.closest('.js-filter-input').length) return;

        const id = $eTarget.closest('.js-filter-input').attr('id')
        const WIDGET_USER_SRNO = id.split('_')[0];
        $this.$props.FIL_END_DT_GUBUN = id.split('_')[2];

        updateEndFilter(e, $this.$props.FIL_END_DT_GUBUN).then(r => {
            $this.setup({
                isDataDrivenRendering: true,
                isInit : true
            })
        });
        $w.find('.button-filter > span').text(i18next.t(getFilterText(filterGb, $this.$props.FIL_END_DT_GUBUN - 1)));
        toggleFilterPopup()
    })
    function toggleFilterPopup() {
        const $pop = $w.find('.widget-filter-mini-pop');
        $pop.toggleClass('d-none');
    }
}


export {
    addFilterEvent
}
